import React from 'react'
import Layout from './layout/Layout'
import ScrollToTop from '../ScrollToTop'
import Helmet from 'react-helmet'
import EnquireNowSection from './views/EnquireNowSection'

class PageNotFound extends React.Component {
    render(){
        return(
            <Layout>
                <Helmet>
                    <title>404 Page Not Found | Graham and Rhona Beck Skills Centre</title>
                    <meta name="robots" content="noindex, nofollow" />
                </Helmet>
                <ScrollToTop />
                <section className='_section _section-contact _section-top-no-banner'>
                    <div className='_grid'>
                        <div className='_column'>
                            <h1 className='_heading-3 _gold'>404 Page Not Found</h1>
                            <p>Oops! The page you are looking for does not exist.</p>
                        </div>
                    </div>
                </section>

                <EnquireNowSection />
            </Layout>
        )
    }
}

export default PageNotFound